export default __webpack_public_path__ + "static/media/BLIQ-BNB.6297a0e3.png";